import type { Box, BoxEntry, BoxInfo } from '@deepcloud/api-deep-box'

export function useBox(box: ComputedRef<Box | BoxInfo | BoxEntry | undefined>) {
  // boxTypes
  const isBoxTypePrivate = computed(() => box.value?.boxType === 'private')
  const isBoxTypeAbaImmo = computed(() => box.value?.boxType === 'abaimmo')

  // boxVariants
  const isBoxVariantAdvanced = computed(
    () => box.value?.boxVariant === 'advanced',
  )

  const isBoxVariantAdvancedPerUse = computed(
    () => box.value?.boxVariant === 'advanced-per-use',
  )

  const isBoxVariantPrivate = computed(
    () => box.value?.boxVariant === 'private',
  )

  // box features
  const isBoxPrivate = computed(
    () => isBoxTypePrivate.value && isBoxVariantPrivate.value,
  )

  return {
    // boxTypes
    isBoxTypePrivate,
    isBoxTypeAbaImmo,
    // boxVariants
    isBoxVariantAdvanced,
    isBoxVariantAdvancedPerUse,
    isBoxVariantPrivate,
    // box features
    isBoxPrivate,
  }
}
